// Setup everything needed (Globals - 3rd party or otherwise to get the app ready to initialize)
import {session} from '@netx/core-auth/collections/singleton/session';
import {initializeI18n, setGlobal} from '@netx/core-next';
import {getPrefixedLogger} from '@netx/core-next/instance/logger';
import {appRouter as router} from '@netx/core-next/instance/router';
import NetxURL from '@netx/core-next/url';
import Netx from '@netx/core/bootstrap';
import './bootstrap';
import css from './css';
import Loading from './lib/netx-loading';
import Router from './lib/netx-routers-app';
import {isBrandPortal} from './utils';

const logger = getPrefixedLogger('app init');

logger.info('version:', Netx.version);

logger.info('initializing...');

// We expect these to be set
setGlobal({
	// this is dead, leaving in the event of a cannnot access x of undefined
	// should not come up... think all references have been removed
	custom: {},
	// Instantiate the global router
	router,
	URL: NetxURL,
	// Routers
	Routers: {
		App: Router,
	},
	// Loading screen
	Loading: new Loading(),
});

const loadInitialData = async () =>
	session.getPublicMethods().then(function () {
		if (isBrandPortal()) {
			logger.info('loading portal data...');
			return import(
				/* webpackChunkName: "current-portal" */ '@netx/core-cms/singletons/currentPortal'
			).then((CurrentPortal) => {
				Netx.cms = Netx.cms || {};
				Netx.cms.portal = CurrentPortal.default;
				return CurrentPortal.default
					.fetchPortalByName()
					.then(() => {
						logger.info('portal data loaded');
					})
					.catch((ex) => {
						logger.error('failed to load portal data', ex.message);
					});
			});
		}
	});

// After i18n (success or fail) and custom css properties we will load the app
const loadApp = async () =>
	// Initialize core
	import(/* webpackChunkName: "@netx/core" */ '@netx/core').then((Core) => {
		Core.default.initialize();
	});

loadInitialData().then(() => {
	Promise.all([
		// Load custom CSS before loading in core
		css(),
		// Load i18n and base locales before loading in core
		initializeI18n(),
	])
		.catch((err) => {
			logger.error('failed to initialize css or i18n', err.message);
		})
		.finally(() => {
			logger.info('initialized');
			loadApp();
		});
});
